import createIcon from '@/lib/create-icon'

const HamburguerIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'>
    <path
      d='M17.0609 3.99976H2.93857C2.42008 3.99976 1.99976 4.40337 1.99976 4.90125C1.99976 5.39913 2.42008 5.80274 2.93857 5.80274H17.0609C17.5794 5.80274 17.9998 5.39913 17.9998 4.90125C17.9998 4.40337 17.5794 3.99976 17.0609 3.99976Z'
      fill='currentColor'
    />
    <path
      d='M17.0609 9.09651H2.93857C2.42008 9.09651 1.99976 9.50012 1.99976 9.998C1.99976 10.4959 2.42008 10.8995 2.93857 10.8995H17.0609C17.5794 10.8995 17.9998 10.4959 17.9998 9.998C17.9998 9.50012 17.5794 9.09651 17.0609 9.09651Z'
      fill='currentColor'
    />
    <path
      d='M17.0609 14.1968H2.93857C2.42008 14.1968 1.99976 14.6004 1.99976 15.0983C1.99976 15.5961 2.42008 15.9998 2.93857 15.9998H17.0609C17.5794 15.9998 17.9998 15.5961 17.9998 15.0983C17.9998 14.6004 17.5794 14.1968 17.0609 14.1968Z'
      fill='currentColor'
    />
  </svg>,
  'HamburguerIcon'
)

export default HamburguerIcon
